import { AxiosError } from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import {
  useAlertMessage,
  useNotification,
  useResource,
} from '@bom-nextgen-keycloak/web/core';
import {
  ErrorMessage,
  fetchResourceById,
  QUERY_KEY,
  updateResource,
} from '@bom-nextgen-keycloak/web/shared/data-access';
import { CONFIG, PARENT_PATH } from '../shared';

export const useResourceDetail2 = (resourceId: string) => {
  const defaultData = null;
  const { clientId } = useResource();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { setAlertMessage } = useAlertMessage();
  const { setNotification } = useNotification();

  const queryKeys = [QUERY_KEY.RESOURCE_DETAIL, resourceId];

  const { data = defaultData, isLoading } = useQuery(
    queryKeys,
    () => fetchResourceById(clientId, resourceId),
    {
      onError: (error: AxiosError<ErrorMessage>) => {
        const message =
          error.response?.data.message || 'Cannot get resource detail';

        setAlertMessage({
          message,
          statusCode: error.response?.status,
          typeStatusMessage: 'error',
        });
        navigate(PARENT_PATH);
      },
      staleTime: CONFIG.query.staleTime,
    }
  );

  const updateMutation = useMutation(updateResource, {
    onError: (error: AxiosError<ErrorMessage>) => {
      const message = error.response?.data.message || 'Cannot update resource';

      setAlertMessage({
        message,
        statusCode: error.response?.status,
        typeStatusMessage: 'error',
      });
    },
    onSuccess: (data) => {
      setNotification({
        message: 'Resource updated',
        type: 'success',
      });
      handleReload();
    },
  });

  const handleReload = () => {
    queryClient.invalidateQueries(queryKeys);
  };

  return {
    data,
    isLoading,
    updateMutation,
  };
};
